<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner4.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">关于凯纳</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiJianJie')">公司简介</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeWenHua')">企业文化</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheHuiZeRen')">社会责任</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZiZhiRongYu')">企业荣誉</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('GongSiZiZhi')">公司资质</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('DangJianGongHui')">党建工会</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YuanGongFengCai')">员工风采</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeHuaCe')">企业画册</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('QiYeXuanChuanPian')">企业宣传片</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ title }}</h2>
                    <div id="contnet">
                        <div class="zoom" v-show="zoom_state" @click="zoom(false)" title="点击关闭"><img :src="zoom_url" /></div>
                        <ul class="rongyu">
                            <li v-for="(rongyu, index) in rongyu_list" :key="index" :class="[rongyu.type == 'horizontal'?'li_h':'li_v' ]">
                                <div :title="rongyu.name" @click="zoom(rongyu.url)">
                                    <img :src="rongyu.url" />
                                    <span>{{ rongyu.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { ZiZhiRongYu } from "../request/api"; // 导入接口


export default {
    name: 'Home',
    data() {
        return {
            title: '企业荣誉',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            webTitle:'',
            webDescription:'',

            zoom_state : false,
            zoom_url:'',

            rongyu_list:[
                {
                    url: require('@/assets/pic/r_002.jpg'),
                    name: '“兴凯湖杯”第十一届黑龙江省创新创业大赛成长组 一等奖',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/r_003.jpg'),
                    name: '2013智能环保应用系统优秀产品奖',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/r_007.jpg'),
                    name: '2020年黑龙江省科学技术奖',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/r_009.jpg'),
                    name: '2023黑龙江软件和信息服务业企业20强',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/r_004.jpg'),
                    name: '2014年哈尔滨市科学技术奖三等奖',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_014.jpg'),
                    name: '民营创新企业30强',
                    type: 'vertical', //竖向
                },
                {
                    url: require('@/assets/pic/r_001.jpg'),
                    name: '“兴凯湖杯”第十一届黑龙江省创新创业大赛成长组 一等奖',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_005.jpg'),
                    name: '2017年黑龙江省人民政府质量奖（提名奖）',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_006.jpg'),
                    name: '2019数字创新大赛',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_008.jpg'),
                    name: '2021全国就业与社会保障先进民营企业',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_010.jpg'),
                    name: '2023黑龙江省安防行业十佳系统集成商',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_011.jpg'),
                    name: '创新创业大赛三等奖（市级）',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_012.jpg'),
                    name: '第八届“创客中国”黑龙江中小企业创新创业大赛 企业组 优秀奖',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_013.jpg'),
                    name: '哈尔滨新区职工科技创新劳动技能竞赛二等奖',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_015.jpg'),
                    name: '数采仪名牌',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_016.jpg'),
                    name: '最具创新力企业2023-2024年度',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_017.jpg'),
                    name: '诚信经营示范单位AAA级',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_018.jpg'),
                    name: '2018百企帮百村联万户突出贡献企业',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_019.jpg'),
                    name: '2022哈尔滨市技术创新示范企业',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_020.jpg'),
                    name: '2022黑龙江省技术创新示范企业',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_021.jpg'),
                    name: '2022年哈尔滨市第38届模范集体',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_022.jpg'),
                    name: '2023哈尔滨新区青年创业就业实践基地',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_023.jpg'),
                    name: '2023校企联合学生培训基地',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_024.jpg'),
                    name: '省级专精特新中小企业',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_025.jpg'),
                    name: '院士工作站',
                    type: 'horizontal', //横向
                },
                {
                    url: require('@/assets/pic/r_026.jpg'),
                    name: '智慧水务研究院',
                    type: 'horizontal', //横向
                }
            ]
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ZiZhiRongYu_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        zoom( e ){
            window.scrollTo({
                top: 300,
                behavior: "smooth"
            });
            //alert( e );
            if( e != false ){
                this.zoom_url = e ;
                this.zoom_state = true;
            }else{
                this.zoom_state = e;
            };
        },
        goTo(e) {
            this.$router.push(e);
        },
        ZiZhiRongYu_data(){ //资质荣誉
            ZiZhiRongYu({
            }).then((res) => {
                this.webTitle = res.rows[0].webTitle;
                this.webDescription = res.rows[0].webDescription;
            });
        },
    },
};
</script>
<style lang="less" scoped>
#contnet{
    position: relative;
    display:block;
    margin-top: 10px;
    min-height: 500px;
    text-align: center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-image: url('./../assets/img/qiyerongyu_bg.png');

    .zoom{
        position: absolute;
        left: 0px;
        top: 30px;
        width: 70%;
        height: auto;
        max-height: 800px;
        margin: 0px 15%;
        background-color: #fff;
        border: 5px solid #999;
        padding: 5px;
        overflow: hidden;
        overflow-y: auto;
        img{
            cursor: pointer;
            max-width: 100%;
            width: 800px;
            height: auto;
            vertical-align: top;
        }
    }
    .rongyu{
        margin: 360px 20px 0px 30px;
        padding: 5px;

        li{
            user-select: none;
            display: inline-block;
            // width: 210px;
            // height: 147px;
            border-top: 8px solid #f9f8f4;
            border-right: 8px solid #efece3;
            border-bottom: 8px solid #eae8e0;
            border-left: 8px solid #f9f8f4;
            background-color: #ebeae6;
            box-shadow: inset 2px 2px 0px #ccc, inset -2px -2px 0px #e4dbdb;
            padding: 10px;
            

            div{
                background-color: #fff;
                width: 100%;
                height: 100%;
                span{
                    cursor: default;
                    display: block;
                    text-align: center;
                    width: 100%;
                    margin-top: 20px;
                    min-height: 30px;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                img{
                    vertical-align: top;
                    height: 100%;
                    max-width: 100%;
                }
            }
        }
        .li_h{
            width: 210px;
            height: 147px;
            margin: 5px 20px;
        }
        .li_v{
            // width: 98px;
            // height: 147px;
            // margin: 5px 76px;
            width: 140px;
            height: 210px;
            margin: 5px 55px;
        }
        li:hover{
            animation: li_hover 0.3s linear forwards;
            @keyframes li_hover {
                0% {
                    border-top: 8px solid #f9f8f4;
                    border-right: 8px solid #efece3;
                    border-bottom: 8px solid #eae8e0;
                    border-left: 8px solid #f9f8f4;
                    background-color: #ebeae6;
                    box-shadow: 5px 5px 0px rgba(255,255,255,0);
                }
                100% {
                    border-top: 8px solid #ecd6b7;
                    border-right: 8px solid #ffffdc;
                    border-bottom: 8px solid #ffffdc;
                    border-left: 8px solid #ecd6b7;
                    background-color: #f2efe5;
                    box-shadow: 5px 5px 0px rgba(0,0,0,0.2);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ZiZhiRongYu.vue